import { Box, CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';

interface PageSpinnerProps {
  debounceMs?: number;
}

export const PageSpinner: React.FC<PageSpinnerProps> = ({ debounceMs = 500 }) => {
  const [show, setShow] = useState(debounceMs === 0);

  useEffect(() => {
    if (debounceMs === 0) {
      setShow(true);
      return;
    }
    const timer = setTimeout(() => setShow(true), debounceMs);
    return () => clearTimeout(timer);
  }, [debounceMs]);

  if (!show) return null;
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress size={120} />
    </Box>
  );
};
